import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'
import Cookies from 'universal-cookie';
import { useJwt, decodeToken } from "react-jwt";

function Security() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();
    const [signedin,setSignedIn] = useState(false)
    const cookies = new Cookies(null ,{ path: '/' });

    const openInNewTab = () => {
        const fromAccountPage = false;
        const fromLogin = false;
    
      
        // Store the state in localStorage or sessionStorage
        localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));
      
        // Open /Dashboard in a new tab
        window.open("/Dashboard/settings/secsettings", "_blank");
      };

      const openLabelInNewTab = () => {
        const fromAccountPage = false;
        const fromLogin = false;
    
      
        // Store the state in localStorage or sessionStorage
        localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));
      
        // Open /Dashboard in a new tab
        window.open("/dashboard/label/settings/secsettings", "_blank");
      };
      

    useEffect(()=>{
        if(cookies.get('token')!==undefined && cookies.get('staysignedin')){
          setSignedIn(true)
        }else{
          setSignedIn(false)
        }
      },[])

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Security
                </div>

                <div className="infoDescHeader">
                ACCOUNT SECURITY
                </div>

                <div className="infoDesc">
                The security tab is dedicated to protecting your account and ensuring your personal information stays up to date and secure. (Login to Reset password/enable MFA)
                </div>


                {
                    signedin &&
                    <div>
                        <div className="infoDesc">
                        <br/>Click <span style={{color:'#6D33C9',cursor:'pointer'}} onClick={()=>  { if(cookies.get('token')!==undefined){
                                                                                                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                                                                                    openInNewTab()
                                                                                                    }
                                                                                            
                                                                                                    if(decodeToken(cookies.get('token')).info.role==="label"){
                                                                                                    openLabelInNewTab()
                                                                                                    }
                                                                                                    
                                                                                                }
                                                                                                
                                                                                                }}>HERE</span> to reset your password
                        </div>

                        <div className="infoDesc">
                        <br/>Click <span style={{color:'#6D33C9',cursor:'pointer'}} onClick={()=>  { if(cookies.get('token')!==undefined){
                                                                                                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                                                                                    openInNewTab()
                                                                                                    }
                                                                                            
                                                                                                    if(decodeToken(cookies.get('token')).info.role==="label"){
                                                                                                    openLabelInNewTab()
                                                                                                    }
                                                                                                    
                                                                                                }
                                                                                                
                                                                                                }}>HERE</span> to enable Multi-Factor Authentifacation (MFA)  
                        </div>
                    </div>
                }

                
                {
                    !signedin &&
                    <div>
                        <div className="infoDesc">
                        <br/>Click <span style={{color:'#6D33C9',cursor:'pointer'}} onClick={()=>navigate("/Login")}>HERE</span> to reset your password
                        </div>

                        <div className="infoDesc">
                        <br/>Click <span style={{color:'#6D33C9',cursor:'pointer'}} onClick={()=>navigate("/Login")}>HERE</span> to enable Multi-Factor Authentifacation (MFA)  
                        </div>
                    </div>
                }
                

                <div className="infoDesc">
                <br/>By enabling MFA, you add an extra layer of security to your account, making it harder for unauthorized users to gain access. 
                </div>


                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default Security;